@switch (true) {
  @case (type === 'image' && imageSrc && true) {
    <img #image [src]="imageSrc" [ngStyle]="imageStyles" (error)="imageError.emit($event)" />
  }

  @case (type === 'image-with-container' && imageSrc && true) {
    <div
      class="image-container"
      [ngStyle]="imageStyles"
      [style.background-image]="'url(' + imageSrc + ')'"
    ></div>
  }

  @case (type === 'initials' && nameInitials && true) {
    <div
      #avatarPlaceholder
      class="avatar-placeholder"
      [class.is-candidate]="context === 'candidate'"
      [class.is-admin]="context === 'admin'"
      [class.is-other]="context === 'other'"
      [class.font-size-backend-style]="fontSize === 'small'"
      [class.colorized]="isColorized"
    >
      <div class="initials">{{ nameInitials }}</div>
    </div>
  }

  @case (type === 'icon' && iconName && true) {
    <div
      class="avatar-icon"
      [class.is-candidate]="context === 'candidate'"
      [class.is-other]="context === 'other'"
    >
      <rt-icon [name]="iconName" [size]="customIconSize || iconSize"></rt-icon>
    </div>
  }

  @case (type === 'custom' && avatarTpl && true) {
    <ng-container *ngTemplateOutlet="avatarTpl!"></ng-container>
  }
}

@if (isOnline) {
  <div class="online-indicator"></div>
}

@if (hasUnreadNotifications) {
  <div class="has-notifications">
    <ng-container *ngTemplateOutlet="tooltipTplRef"></ng-container>
  </div>
}
